import LayoutRoute from './LayoutRoute'

function processRelationship( molten, relationship, options ) {
  const { blueprint } = relationship

  if ( blueprint.type === 'moldHalf' && relationship.path === 'location.molds.uwMold' ) {
    LayoutRoute.create( molten, {
      id : 'tpi.store.HeadCount.Uw',
      relationship,
      layoutName : 'Head Count',
      icon : 'fa-solid fa-grid-2',
      layout : {
        sort : 'z.5',
      },
      matches : { 
        use : 'navBar',
        client : 'ItemScreen',
        objectType : 'moldHalf',
        path : relationship.path
      },
      linkPath : `${relationship.urlPath}/headCount`,
      isItem : true,
      embed : true,
    } )
  }

  if ( blueprint.type === 'moldHalf' && relationship.path === 'location.molds.lwMold' ) {
    LayoutRoute.create( molten, {
      id : 'tpi.store.HeadCount.Lw',
      relationship,
      layoutName : 'Head Count',
      icon : 'fa-solid fa-grid-2',
      layout : {
        sort : 'z.5',
      },
      matches : { 
        use : 'navBar',
        client : 'ItemScreen',
        objectType : 'moldHalf',
        path : relationship.path
      },
      linkPath : `${relationship.urlPath}/headCount`,
      isItem : true,
      embed : true,
    } )
  }
}

export default {
  id : 'tpi.store.BlueprintRouteCreator3',
  type : 'tpi.store.BlueprintRouteCreator3',
  processRelationship,
}
